export const rowsPerPageOptions = [5, 10, 25]